<template>
  <div class="discount-infobox">{{ text }}</div>
</template>

<script>
export default {
  name: "DiscountInfobox",
  props: {
    text: String,
  },
};
</script>

<style scoped lang="scss">
.discount-infobox {
  display: inline-block;
  color: $brand-orange;
  border: 2px dashed $brand-orange;
  border-radius: $border-radius-large;
  padding: 0.8rem 1.2rem;
  margin: 0 auto 1.5rem auto;
  font-size: 16px;
  font-weight: $font-bold;
  white-space: pre-wrap;
}
</style>
